import * as Yup from 'yup';
import { AlertsStatus } from '../../../../../../shared/types/legalProceedings/alerts';

export const initialValues: AlertsStatus = {
    nameAlert: '',
    active: true,
    newPqrStatus: '',
    observation: '',
};

export const validationSchema = () =>
    Yup.object({
        nameAlert: Yup.string().required('El Nombre es obligatorio'),
        newPqrStatus: Yup.string().required('El estado PQR es obligatorio'),
        observation: Yup.string().required('La observación es obligatoria'),
    });
